/**
 * @generated SignedSource<<1f875bf57b59763d4f738e51dfc31780>>
 * @relayHash 3c5663fa700ea9d17cd173c25dc6092f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ad426d494434808a1d151a010a3be183445c1bbfd9b6b01f88d0f08608a5ecbe

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type overview_agentIdentityQuery$variables = {
  helpCenterAri: string;
};
export type overview_agentIdentityQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly " $fragmentSpreads": FragmentRefs<"agentIdentity_AtlassianCsmAgentIdentity">;
    } | null | undefined;
  } | null | undefined;
};
export type overview_agentIdentityQuery = {
  response: overview_agentIdentityQuery$data;
  variables: overview_agentIdentityQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  {
                    "kind": "FragmentSpread",
                    "name": "agentIdentity_AtlassianCsmAgentIdentity"
                  }
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "overview_agentIdentityQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "companyName"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "companyDescription"
                      },
                      {
                        "concreteType": "CsmAiAgentTone",
                        "kind": "LinkedField",
                        "name": "tone",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "type"
                          }
                        ]
                      }
                    ],
                    "type": "CsmAiAgent"
                  }
                ]
              },
              (v3/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "ad426d494434808a1d151a010a3be183445c1bbfd9b6b01f88d0f08608a5ecbe",
    "metadata": {},
    "name": "overview_agentIdentityQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ad2118276853b2acba85a665b99d4060";

export default node;
